module.exports = __webpack_public_path__ + "e15ddeabbfce297178193b7858043ebd.svg";